module.exports = __webpack_public_path__ + "static/media/11756645_978907305483056_820914096_n.75101966.jpg";